export default __webpack_public_path__ + "static/media/demag-white.cb017b8a.svg";